import React__default from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import styles from 'ui-components/SkipToContent.scss';

var SkipToContent = function SkipToContent() {
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "#main",
    className: styles.link
  }, t("SKIP_TO_CONTENT")));
};

export { SkipToContent };
//# sourceMappingURL=index.js.map
